import React, { useState, useEffect } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import NoDataFound from "../../../partials/NoDataFound"
import { trans } from "../../../../_providers/Translation"
import SubscriptionOptions from "../list/SubscriptionOptions"
import moment from "moment"
import alertImage from "@/assets/img/contractors/icons/alert.svg"
import { Tooltip } from "@mui/material"
import Pagination from "@/components/Pagination"
import checkIcon from "@/assets/img/icons/check.png"
import crossIcon from "@/assets/img/icons/cross.svg"
import SubscriptionFilter from "./SubscriptionFilter"
import { useHistory, useLocation } from "react-router-dom"

let timeout

export default function SubscriptionsList({
  handleEdit,
  handleDelete,
  handleActivate,
  handleRenew,
  handleDeactivate,
  refresh,
}) {
  const location = useLocation()
  const history = useHistory()

  const searchParams = new URLSearchParams(location.search)

  const page = searchParams.get("page") || 1
  const name = searchParams.get("name") || ""
  const categoryId = searchParams.get("category_id") || ""
  const brandId = searchParams.get("brand_id") || ""
  const model = searchParams.get("model") || ""
  const contractorId = searchParams.get("contractor_id") || ""
  const dueToPay = searchParams.get("due_to_pay") || ""
  const startDate = searchParams.get("start_date") || ""
  const endDate = searchParams.get("end_date") || ""
  const status = searchParams.get("status") || ""

  const [data, setData] = useState({
    loading: true,
    data: [],
    page: 1,
    pages: 0,
    update: false,
    filter: {},
    setFilter: false,
  })

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      page: page,
      filter: {
        ...prev.filter,
        name: name,
        category_id: categoryId,
        contractor_id: contractorId,
        due_to_pay: dueToPay,
        start_date: startDate,
        end_date: endDate,
        status: status,
      },
      update: new Date().getTime(),
    }))
  }, [page, name, categoryId, contractorId, dueToPay, startDate, endDate, status])

  useEffect(() => {
    if (data.setFilter) {
      searchParams.set("page", data.page)

      Object.entries(data.filter).map((filter) => {
        // if (filter[1]) {
        searchParams.set(filter[0], filter[1])
        // }
      })

      let url = "?" + searchParams.toString()

      history.push(url)
    }
  }, [data.setFilter])

  useEffect(() => {
    loadSubscriptions()
  }, [refresh, data.update])

  const loadSubscriptions = () => {
    setData((prev) => ({
      ...prev,
      loading: true,
    }))

    let url = "subscriptions?page=" + data.page

    Object.entries(data.filter).map((filter) => {
      url += "&" + filter[0] + "=" + filter[1]
    })

    Api.get(url)
      .then((res) => {
        setData((prev) => ({
          ...prev,
          loading: false,
          data: res.data.items,
          pages: res.data.pages,
        }))
      })
      .catch(() => {
        setData((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  const handlePage = (page) => {
    setData((prev) => ({
      ...prev,
      page: page.selected + 1,
      update: new Date().getTime(),
    }))
  }

  //Search
  const handleSearch = (key, val) => {
    clearTimeout(timeout)

    setData((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [key]: val,
      },
    }))

    timeout = setTimeout(() => {
      setData((prev) => ({
        ...prev,
        page: 1,
        setFilter: new Date().getTime(),
      }))
    }, 300)
  }

  return (
    <div className="pannel">
      <h3>{trans("headings.subscriptions")}</h3>
      <SubscriptionFilter
        filter={data.filter}
        types={data.types || []}
        handleSearch={handleSearch}
      />
      <hr />
      {data.loading ? (
        <Skeleton height={45} count={10} />
      ) : data.data.length === 0 ? (
        <NoDataFound message={trans("messages.noAddedSubscriptions")} />
      ) : (
        <>
          <div className="table-scroller">
            <table>
              <thead>
                <tr>
                  {/* <th>{trans("tables.refNo")}</th> */}
                  <th>{trans("tables.name")}</th>
                  <th>{trans("tables.status")}</th>
                  <th>{trans("tables.fromDate")}</th>
                  <th>{trans("tables.expiresOn")}</th>
                  <th>{trans("tables.type")}</th>
                  <th>{trans("tables.contractor")}</th>

                  {/* <th>{trans("tables.devicesCountFull")}</th> */}

                  <th>{trans("tables.invoice")}</th>
                  <th>{trans("tables.paid")}</th>
                  <th className="options">{trans("tables.options")}</th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((sub) => {
                  const daysUntilDue = moment(
                    sub.expires_at_dmy,
                    "DD.MM.YYYY",
                  ).diff(moment(), "days")
                  const isOverdue = daysUntilDue <= 0
                  const isNear = daysUntilDue > 0 && daysUntilDue <= 20

                  return (
                    <tr key={"sub-" + sub.id}>
                      {/* <td>{sub.ref || "-"}</td> */}
                      <td>{sub.name || "-"}</td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <span
                            style={{
                              width: "12px",
                              height: "12px",
                              borderRadius: "50%",
                              backgroundColor: sub.is_active
                                ? "#4BB543"
                                : "#EC5252",
                            }}
                          ></span>
                          {sub.is_active
                            ? trans("random.activeStatus")
                            : trans("random.inactiveStatus")}
                        </div>
                      </td>
                      <td>
                        {sub.activated_at_dmy
                          ? moment(sub.activated_at_dmy, "DD.MM.YYYY").format(
                              "DD MMM YYYY",
                            )
                          : "-"}
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {!sub.expires_at_dmy ? (
                            trans("random.indefinite")
                          ) : (
                            <>
                              {isOverdue && (
                                <Tooltip
                                  title={trans(
                                    "messages.subscriptionHasExpired",
                                  )}
                                >
                                  <img src={alertImage} alt="" />
                                </Tooltip>
                              )}
                              {moment(sub.expires_at_dmy, "DD.MM.YYYY").format(
                                "DD MMM YYYY",
                              )}
                              {!isOverdue && (
                                <span
                                  style={isNear ? { color: "#EC5252" } : {}}
                                >{`(${daysUntilDue} ${trans("labels.days")})`}</span>
                              )}
                            </>
                          )}
                        </div>
                      </td>
                      <td>{sub?.type?.name || "-"}</td>
                      <td>{sub?.contractor?.name || "-"}</td>

                      {/* <td>{sub?.appliances_count || "-"}</td> */}

                      <td>
                        {sub.last_invoice?.number ? (
                          <Tooltip
                            title={`${trans("labels.dueToPay")} / ${moment(sub.last_invoice?.due_date, "YYYY-MM-DD").format("DD MMM YYYY")}`}
                          >
                            <a
                              href={sub.last_invoice?.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {`#${sub.last_invoice?.number}`}
                            </a>
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td
                        style={
                          sub.last_invoice
                            ? {
                                color: sub.last_invoice?.is_paid
                                  ? "green"
                                  : "red",
                              }
                            : {}
                        }
                      >
                        {sub.last_invoice ? (
                          sub.last_invoice?.is_paid ? (
                            <>
                              <img src={checkIcon} alt="completed" /> Платена
                            </>
                          ) : (
                            <>
                              <img src={crossIcon} alt="not completed" />{" "}
                              Неплатена
                            </>
                          )
                        ) : (
                          "-"
                        )}
                      </td>

                      <td>
                        <SubscriptionOptions
                          id={sub.id}
                          data={sub}
                          handleEdit={handleEdit}
                          handleDelete={handleDelete}
                          handleActivate={handleActivate}
                          handleRenew={handleRenew}
                          handleDeactivate={handleDeactivate}
                        />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            pages={data.pages}
            page={data.page}
            handlePage={handlePage}
          />
        </>
      )}
    </div>
  )
}
